// Clicking anywhere on a date box opens the calendar (Stephanie 2026-10-26:
// "the entire box should be clickable not just the calendar icon"). One
// listener for every date / time box in the app — the browser only opens its
// picker from the little icon otherwise. Typing a date still works.
const PICKER_TYPES = new Set(["date", "datetime-local", "month", "week", "time"]);

/** Pure: should a click on this element open its picker? */
export function opensPicker(el: { tagName?: string; type?: string; disabled?: boolean; readOnly?: boolean } | null): boolean {
  return !!el && el.tagName === "INPUT" && PICKER_TYPES.has(el.type ?? "") && !el.disabled && !el.readOnly;
}

export function openDatePickersOnClick(doc: Document): void {
  doc.addEventListener("click", (e) => {
    const el = e.target as HTMLInputElement | null;
    if (!opensPicker(el)) return;
    try {
      el!.showPicker?.();
    } catch {
      // Already open, or the browser refused — the icon still works.
    }
  });
}
